import { combineReducers } from 'redux'

import { configReducer } from '~/app/store/config'
import { designReducer } from '~/app/store/design'
import { facetReducer } from '~/app/store/facet'
import { filterByCategoryReducer } from '~/app/store/filterByCategory'
import { filterCategoriesReducer } from '~/app/store/filterCategories'
import { filterByOptionReducer } from '~/app/store/filterByOption'
import { filterOptionReducer } from '~/app/store/filterOption'
import { filterReducer } from '~/app/store/filter'
import { quickViewFilterReducer } from '~/app/store/quickViewFilter'
import { pagingReducer } from '~/app/store/paging'
import { productOptionsByProductKeyReducer } from '~/app/store/productOptionsByProductKey'
import { refinementReducer } from '~/app/store/refinement'
import { tileEntityReducer } from '~/app/store/tileEntity'
import { uxReducer } from '~/app/store/ux'
import { debugReducer } from '~/app/store/debug'
import { experimentationReducer } from '~/app/store/experimentation'
import { optionNameByFilterNameReducer } from '~/app/store/optionNameByFilterName'
import { attributeNameByFilterNameReducer } from '~/app/store/attributeNameByFilterName'
import { similarTemplatesReducer } from '~/app/store/similarTemplates'
import { authReducer } from '~/app/store/auth'
import { designPersonalizationReducer } from '~/app/store/designPersonalization'
import { previouslyOrderedReducer } from '~/app/store/previouslyOrdered'
import { taxonomyIdByFilterNameReducer } from '~/app/store/refinement/taxonomyIdByFilterName'
import { taxonomyIdByCategoryIdStateReducer } from '~/app/store/taxonomyIdByCategoryId'
import { qvFilterNameByTaxonomyIdReducer } from '~/app/store/qvFilterNameByTaxonomyId'
import { debugToolbarReducer } from '~/app/store/debugToolbar'
import type { State } from 'shared/types/gallery/state'

/* eslint-disable @typescript-eslint/no-explicit-any */
//TODO MIGRATION T011: Fix eslint errors

export const rootReducer = combineReducers<State.GlobalState>({
  config: configReducer,
  debug: debugReducer,
  debugToolbar: debugToolbarReducer,
  designs: designReducer,
  facets: facetReducer,
  filterByCategory: filterByCategoryReducer,
  filterByOption: filterByOptionReducer,
  optionNameByFilterName: optionNameByFilterNameReducer,
  attributeNameByFilterName: attributeNameByFilterNameReducer,
  filterCategories: filterCategoriesReducer,
  filterOptions: filterOptionReducer,
  filters: filterReducer,
  quickViewFilters: quickViewFilterReducer,
  paging: pagingReducer,
  previouslyOrdered: previouslyOrderedReducer,
  productOptionsByProductKey: productOptionsByProductKeyReducer,
  refinements: refinementReducer,
  tileEntities: tileEntityReducer,
  ux: uxReducer,
  experimentation: experimentationReducer,
  designPersonalization: designPersonalizationReducer,
  taxonomyIdByCategoryId: taxonomyIdByCategoryIdStateReducer,
  taxonomyIdByFilterName: taxonomyIdByFilterNameReducer,
  qvFilterNameByTaxonomyId: qvFilterNameByTaxonomyIdReducer,
  authData: authReducer,
  similarTemplates: similarTemplatesReducer,
} as any)
